import React, { useState } from "react";
import Rc_TrcCaseStatusReport from "./Rc_TrcCaseStatusReport/Rc_TrcCaseStatusReportParent";
import { Link } from "react-router-dom";
import DrtCaseStatusParent from "./DrtCaseStatusReport/DrtCaseStatusParent";
import DratCaseStatusParent from "./DratCaseStatusReport/DratCaseStatusParent";
import { useTitle } from "../../../services/PageTitle";

const CaseDetailParent = () => {
  useTitle("Case Details");

  const [relatedLink, setRelatedLink] = useState("DratCaseStatusReport");

  return (
    <div>
      <div className="inner-bg">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="b-title">
                <h5>CASE DETAILS</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="breadcrumb-bg">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item" aria-current="page">
                    Case Details
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {relatedLink === "DratCaseStatusReport"
                      ? "DRAT Case Status Report"
                      : relatedLink === "DrtCaseStatusReport"
                      ? "DRT Case Status Report"
                      : "RC/TRC Case Status Report"}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="common-bg mb-4">
        <div className="container">
          <div className="row">
            {/* Main Content */}
            <div className="col-12 col-sm-12 col-md-12 col-lg-8 pt-4 inner-side-nav">
              {relatedLink === "DratCaseStatusReport" ? (
                <DratCaseStatusParent />
              ) : relatedLink === "DrtCaseStatusReport" ? (
                <DrtCaseStatusParent />
              ) : (
                <Rc_TrcCaseStatusReport />
              )}
            </div>

            {/* Sidebar */}
            <div className="col-12 col-sm-12 col-md-12 col-lg-4 p-static">
              <div className="bg-shade"></div>
              <div className="right-menu">
                <h3>Related Links</h3>
                <ul>
                  <li>
                    <span
                      role="button"
                      tabIndex="0"
                      aria-label="View DRAT Case Status Report"
                      className={
                        relatedLink === "DratCaseStatusReport" ? "active" : ""
                      }
                      onClick={() => setRelatedLink("DratCaseStatusReport")}
                      onKeyDown={(e) =>
                        e.key === "Enter" &&
                        setRelatedLink("DratCaseStatusReport")
                      }
                    >
                      DRAT Case Status
                    </span>
                  </li>

                  <li>
                    <span
                      role="button"
                      tabIndex="0"
                      aria-label="View DRT Case Status Report"
                      className={
                        relatedLink === "DrtCaseStatusReport" ? "active" : ""
                      }
                      onClick={() => setRelatedLink("DrtCaseStatusReport")}
                      onKeyDown={(e) =>
                        e.key === "Enter" &&
                        setRelatedLink("DrtCaseStatusReport")
                      }
                    >
                      DRT Case Status
                    </span>
                  </li>

                  <li>
                    <span
                      role="button"
                      tabIndex="0"
                      aria-label="View RC/TRC Case Status Report"
                      className={
                        relatedLink === "Rc_TrcCaseStatusReport" ? "active" : ""
                      }
                      onClick={() => setRelatedLink("Rc_TrcCaseStatusReport")}
                      onKeyDown={(e) =>
                        e.key === "Enter" &&
                        setRelatedLink("Rc_TrcCaseStatusReport")
                      }
                    >
                      RC/TRC Case Status
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseDetailParent;
